// @flow

import { gql } from '@apollo/client';

export const GET_GLOBAL_INVOICE = gql`
  mutation GetGlobalInvoice($id: String) {
    getGlobalInvoice(id: $id) {
      url
    }
  }
`;
